import { render, staticRenderFns } from "./StudentExaminationRoom.vue?vue&type=template&id=46c7323e&"
import script from "./StudentExaminationRoom.vue?vue&type=script&lang=js&"
export * from "./StudentExaminationRoom.vue?vue&type=script&lang=js&"
import style0 from "./StudentExaminationRoom.vue?vue&type=style&index=0&id=46c7323e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports